/**
 * FreeOptionsList scene
 *
 * @author Carlos Silva <csilva@ubiwhere.com>
 *
 */

import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';

import PageStructure from 'shared/containers/PageStructure';
import Header from 'shared/containers/TitleHeader';

import { Text } from '@paco_ua/pacoui';

import numeral from 'numeral';

import IsolatedOptionsTable from 'scenes/Schedules/containers/IsolatedOptionsTable';

import { actions } from 'store/rootSlices';
import * as selectors from './logic/selectors';

//import config from 'config'

const IsolatedOptionsList = ({ t }) => {
  const { setError, setLoading, setPeriod } = actions.IsolatedOptionsList;

  const dispatch = useDispatch();

  const { loading, error, year, semester } = useSelector(selectors.getIsolatedOptionsListSlice);

  return (
    <PageStructure
      expanded
      loading={loading || error}
      headerLeft={<Header backButton title={t('sgh.isolatedOptionsList')} />}
      subHeader={
        year !== null &&
        semester !== null && (
          <Text color="plusDarkGrey" size="large" fontWeight="400">
            {`${year}/${year + 1} - ${t('sgh.semestersIsolatedTitle', {
              textOnly: true,
            })}`}
          </Text>
        )
      }
      mainContent={
        <ContentWrapper>
          <IsolatedOptionsTable
            mandatoryFilters
            t={t}
            onLoad={(_loading) => {
              dispatch(setLoading(_loading));
            }}
            onError={(_error) => {
              dispatch(setError(_error));
            }}
            onPeriod={(period) => {
              dispatch(setPeriod(period));
            }}
          />
        </ContentWrapper>
      }
    />
  );
};

export default IsolatedOptionsList;

const ContentWrapper = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
`;
